import { render, staticRenderFns } from "./com_number.vue?vue&type=template&id=72296d16&scoped=true"
import script from "./com_number.vue?vue&type=script&lang=js"
export * from "./com_number.vue?vue&type=script&lang=js"
import style0 from "./com_number.vue?vue&type=style&index=0&id=72296d16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72296d16",
  null
  
)

export default component.exports